import { render } from "./ListaVariaveis.vue?vue&type=template&id=6640fcf4&scoped=true&ts=true"
import script from "./ListaVariaveis.vue?vue&type=script&lang=ts"
export * from "./ListaVariaveis.vue?vue&type=script&lang=ts"

import "./ListaVariaveis.vue?vue&type=style&index=0&id=6640fcf4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6640fcf4"]])

export default __exports__